export const BINDER_BUILDERS_EMAIL = "binderbuilderscanada@gmail.com";

export const BINDER_BUILDERS_FORM_EMBED_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSc9cBOIj--8nGCJ-cVBbW1wFDVcoJLbROae-DzbP1Kz_qHtVw/viewform?embedded=true";

export const BINDER_BUILDERS_FORM_PUBLIC_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSc9cBOIj--8nGCJ-cVBbW1wFDVcoJLbROae-DzbP1Kz_qHtVw/viewform?usp=sharing";

export default function BinderBuildersInquiryForm() {
  return (
    <section id="order-inquiry" style={styles.section}>
      <div style={styles.copyBlock}>
        <h2 style={styles.title}>Order Inquiry</h2>
        <p style={styles.copy}>
          Interested in ordering or have a question? Use the quick links below
          or fill out the embedded form and we'll reply by email.
        </p>
      </div>

      <div style={styles.fallbacks}>
        <p style={styles.fallbackCopy}>
          Prefer to open the form separately?{" "}
          <a
            href={BINDER_BUILDERS_FORM_PUBLIC_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={styles.link}
          >
            Open order inquiry form
          </a>
        </p>
        <p style={styles.fallbackCopy}>
          Prefer email? Reach us directly at{" "}
          <a href={`mailto:${BINDER_BUILDERS_EMAIL}`} style={styles.link}>
            {BINDER_BUILDERS_EMAIL}
          </a>
        </p>
      </div>

      <div style={styles.frameWrap}>
        <iframe
          src={BINDER_BUILDERS_FORM_EMBED_URL}
          title="B's Binder Builders Order Inquiry Form"
          width="100%"
          height="900"
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
          style={styles.iframe}
        >
          Loading...
        </iframe>
      </div>
    </section>
  );
}

const styles = {
  section: {
    boxSizing: "border-box",
    width: "100%",
    background: "#F7F3E8",
    border: "2px solid #6897A9",
    borderLeft: "6px solid #F0DBA5",
    borderRadius: 14,
    padding: "clamp(20px, 4vw, 28px)",
    marginTop: 30,
    color: "#1F2528",
    overflow: "hidden",
    boxShadow: "0 10px 24px rgba(0, 0, 0, 0.18)",
  },

  copyBlock: {
    maxWidth: 720,
    marginBottom: 14,
  },

  title: {
    margin: "0 0 8px 0",
    fontSize: 20,
    fontWeight: 900,
    color: "#1F2528",
    letterSpacing: "-0.02em",
  },

  copy: {
    margin: 0,
    fontSize: 15,
    lineHeight: 1.6,
    color: "#1F2528",
  },

  frameWrap: {
    width: "100%",
    overflow: "auto",
    border: "1px solid #6897A9",
    borderRadius: 10,
    background: "#FFFFFF",
    maxHeight: 900,
  },

  iframe: {
    display: "block",
    width: "100%",
    maxWidth: "100%",
    border: 0,
  },

  fallbacks: {
    marginBottom: 14,
  },

  fallbackCopy: {
    margin: "8px 0 0 0",
    fontSize: 14,
    lineHeight: 1.5,
    color: "#1F2528",
    overflowWrap: "anywhere",
  },

  link: {
    color: "#385D6B",
    fontWeight: 800,
    textDecorationColor: "#6897A9",
    textUnderlineOffset: 3,
  },
};
